module.exports = __webpack_public_path__ + "static/media/noImage.98df040d.png";